module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (172).9d7910fc.jpg";